import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Button from 'material-ui/Button';
import Typography from 'material-ui/Typography';
import Paper from 'material-ui/Paper';
import Grid from 'material-ui/Grid';
import TextField from 'material-ui/TextField';
import { Divider } from 'material-ui';
import { connect } from 'react-redux';
import { fetchTokenIfNeeded, invalidateToken, invalidateSessionInfo, resendActivationcode } from './actions/login';
import { fetchActivationIfNeeded } from './actions/activated';
import { green, red } from 'material-ui/colors';

const styles = theme => ({
    root: {
        flexGrow: 1,
        padding: theme.spacing.unit * 2,
    },
    videreButton: {
        marginTop: theme.spacing.unit * 2,
    },
    aktiverButton: {
        marginTop: theme.spacing.unit * 2,
        backgroundColor: theme.palette.success.main,
        color: green[50],
        '&:hover': {
            backgroundColor: green[700],
        },
        '&:disabled': {
            backgroundColor: green[200],
        },
    },
    gensendButton: {
        marginTop: theme.spacing.unit * 2,
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.getContrastText(theme.palette.primary.main),
        '&:hover': {
            backgroundColor: theme.palette.primary.main,
        },
    },
    annullerButton: {
        marginTop: theme.spacing.unit * 2,
        backgroundColor: theme.palette.danger.main,
        color: red[50],
        '&:hover': {
            backgroundColor: red[700],
        },
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    divider: {
        marginTop: theme.spacing.unit * 3,
        marginBottom: theme.spacing.unit,
    },
    marginTop: {
        marginTop: theme.spacing.unit * 2
    }
});

class Login extends React.Component {
    constructor() {
        super();
        this.state = {
            telefonnummer: '',
            kodeord: '',
            aktiveringskode: '',
            validate: false,
        };
        this.handleChange = this.handleChange.bind(this);
    }

    sendStepOne = () => {
        this.props.dispatch(fetchTokenIfNeeded(this.state.telefonnummer, this.state.kodeord));
    };

    sendStepTwo = () => {
        this.props.dispatch(fetchActivationIfNeeded(this.state.aktiveringskode));
    };

    resendActivationcode = () => {
        this.props.dispatch(resendActivationcode(this.props.token));
    };

    cancelStepTwo = () => {
        this.props.dispatch(invalidateToken());
        this.props.dispatch(invalidateSessionInfo());
        this.setState({
            telefonnummer: '',
            kodeord: '',
            aktiveringskode: '',
            validate: false,
        });
    };

    handleChange(evt) {
        this.setState({ [evt.target.name]: evt.target.value });
    }

    render() {
        const { classes, loginError } = this.props;
        return (
            <div className={classes.root}>
                <Grid container justify="center">
                    <Grid item xs={12} sm={12} md={9} lg={6}>
                        <Paper className={classes.paper}>
                            {!this.props.sessionInfo ? (
                                <div>
                                    <Typography variant="headline" align="left">
                                        Log på
                                    </Typography>
                                    {/* <form
                                    className={classes.form}
                                    noValidate
                                    autoComplete="off"
                                    onSubmit={this.sendStepOne}
                                > */}
                                    <TextField
                                        name="telefonnummer"
                                        onChange={this.handleChange}
                                        id="telefonnummer"
                                        error={!this.state.telefonnummer && this.state.validate}
                                        value={this.state.telefonnummer}
                                        label="Telefonnummer"
                                        fullWidth
                                        helperText="Skal være 8 cifre"
                                    />
                                    <TextField
                                        name="kodeord"
                                        onChange={this.handleChange}
                                        value={this.state.kodeord}
                                        id="kodeord"
                                        label="Kodeord"
                                        fullWidth
                                        error={loginError}
                                        helperText={loginError ? loginError : 'De 5 tegn som er postens kodeord'}
                                    />
                                    <Button
                                        className={classes.videreButton}
                                        variant="raised"
                                        fullWidth={true}
                                        onClick={this.sendStepOne}
                                        disabled={
                                            !(this.state.telefonnummer.length === 8 && this.state.kodeord.length === 5)
                                        }
                                    >
                                        Videre
                                    </Button>
                                    <Typography align="center" className={classes.marginTop}>
                                        <a href="https://filer.mesterskabet.dk/website/static/SJAK-APP-Userguide-rev2021-1.pdf" target="_blank" rel="noopener noreferrer">Brugervejledning</a>
                                    </Typography>
                                    <Typography align="center" className={classes.marginTop}>
                                        <a href="https://www.google.com/maps/d/u/0/edit?hl=da&mid=17rQk3BMqKYOhxCySOZP8XfDndIaOKDI&ll=55.720907319775506,12.3767024744153&z=14" target="_blank" rel="noopener noreferrer">Oversigt over posterne</a>
                                    </Typography>
                                    <Typography align="center" className={classes.marginTop}>
                                        Ring til receptionen på <a href="tel:30141304">30 14 13 04</a>
                                    </Typography>
                                    {/* </form> */}
                                </div>
                            ) : (
                                <div>
                                    <Typography variant="headline" align="left">
                                        {this.props.sessionInfo.sjakData && <span>
                                            {this.props.sessionInfo.sjakData.role === "postmandskab" && <span>
                                                {this.props.sessionInfo.post.betegnelse} - {this.props.sessionInfo.post.postnavn}
                                            </span>}
                                        </span>}
                                        {this.props.sessionInfo.sjakData && <span>
                                            {this.props.sessionInfo.sjakData.role === "sjakleder" && <span>
                                                Kapitelleder på {this.props.sessionInfo.finalekapitel.kapitel_betegnelse}
                                            </span>}
                                        </span>}
                                    </Typography>
                                    <Typography variant="subheading" align="left">
                                        Telefonnummer {this.props.sessionInfo.telefonnummer}
                                    </Typography>
                                    <TextField
                                        name="aktiveringskode"
                                        onChange={this.handleChange}
                                        id="aktiveringskode"
                                        label="Aktiveringskode"
                                        value={this.state.aktiveringskode}
                                        autoComplete="one-time-code"
                                        inputProps={{ 'inputmode': 'numeric', 'pattern': "\\d{6}", }}
                                        fullWidth
                                        error={loginError}
                                        helperText={loginError ? loginError : 'Den 6 cifrede kode som i modtog på sms'}
                                    />
                                    <Button
                                        className={classes.aktiverButton}
                                        variant="raised"
                                        fullWidth={true}
                                        onClick={this.sendStepTwo}
                                        disabled={!(this.state.aktiveringskode.length === 6)}
                                    >
                                        Aktivér
                                    </Button>
                                    <Divider className={classes.divider} />
                                    <Button
                                        className={classes.gensendButton}
                                        variant="raised"
                                        color="inherit"
                                        fullWidth={true}
                                        onClick={this.resendActivationcode}
                                    >
                                        Gensend aktivering
                                    </Button>
                                    <Button
                                        className={classes.annullerButton}
                                        variant="raised"
                                        fullWidth={true}
                                        onClick={this.cancelStepTwo}
                                    >
                                        Annullér aktivering
                                    </Button>
                                </div>
                            )}
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        );
    }
}

Login.propTypes = {
    classes: PropTypes.object.isRequired,
};
function mapStateToProps(state) {
    return {
        sessionInfo: state.sessionInfo,
        token: state.token,
        loginError: state.loginError,
    };
}

export default connect(mapStateToProps)(withStyles(styles)(Login));
